import { render } from "./InputForm.vue?vue&type=template&id=0e903c0c"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"
script.render = render

export default script